import {
    useMemo,
} from 'react'

import LaneFees, {
    LaneFeesCreate, LaneFeesUpdate, LaneFeesCopy, LaneFeesActionButtons,
} from 'app/shared-components/LaneFees'
import useHasPermission from 'app/hooks/useHasPermission'
import {
    LaneFeesStatus,
} from 'app/enums/label.enums'

const LaneFeesTable = () => {
    const contractBasisCreatePermission = useHasPermission(['contract_basis_create'])
    const contractBasisUpdatePermission = useHasPermission(['contract_basis_update'])
    const actionComponents = useMemo(() => {
        return {
            Copy: LaneFeesCopy,
            Create: contractBasisCreatePermission ? LaneFeesCreate : undefined,
            Update: (props) => {
                return (
                    <LaneFeesUpdate
                        {...props} // eslint-disable-line react/jsx-props-no-spreading
                        disabled={!contractBasisUpdatePermission}
                        applyScroll
                        buttonsConfig={{
                            [LaneFeesStatus.SUBMITTED]: [
                                LaneFeesActionButtons.Copy,
                                LaneFeesActionButtons.SetInProgress,
                                LaneFeesActionButtons.SetToAwarded,
                                LaneFeesActionButtons.SetToRejected,
                                LaneFeesActionButtons.SetToCancelled,
                                LaneFeesActionButtons.ChangeValidity,
                            ],
                            [LaneFeesStatus.IN_PROGRESS]: [
                                LaneFeesActionButtons.Copy,
                                LaneFeesActionButtons.SetAsSubmitted,
                                LaneFeesActionButtons.SetToCancelled,
                            ],
                            [LaneFeesStatus.REJECTED]: [
                                LaneFeesActionButtons.Copy,
                                LaneFeesActionButtons.SetToAwarded,
                                LaneFeesActionButtons.SetToCancelled,
                            ],
                            [LaneFeesStatus.CANCELLED]: [
                                LaneFeesActionButtons.Copy,
                                LaneFeesActionButtons.Archive,
                            ],
                            [LaneFeesStatus.AWARDED]: [
                                LaneFeesActionButtons.Copy,
                                LaneFeesActionButtons.SetToCancelled,
                                LaneFeesActionButtons.ChangeValidity,
                            ],
                        } as Record<LaneFeesStatus, LaneFeesActionButtons[]>}
                    />
                )
            },
        }
    }, [
        contractBasisCreatePermission,
        contractBasisUpdatePermission,
    ])

    return (
        <LaneFees
            actionComponents={actionComponents}
            showGeneralInfoCard
        />
    )
}

export default LaneFeesTable
